function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowCircleUpFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 16a15 15 0 1030 0 15 15 0 00-30 0zm15.03-7.5a1.2 1.2 0 01.87.354l4.923 4.938a1.207 1.207 0 11-1.707 1.71l-2.895-2.892v9.69a1.2 1.2 0 11-2.4 0v-9.717l-2.919 2.919a1.21 1.21 0 11-1.71-1.71l4.923-4.938a1.2 1.2 0 01.855-.354h.06z",
    fill: props.color
  }));
}

export default SvgIconArrowCircleUpFilled;